import { TSelectOption, TSelectValue } from '@/ui/types';

export const isSelectedValue = (selectedValue: TSelectValue[] | null, currentOption: TSelectOption) => {
  if (!selectedValue || !selectedValue.length) return false;
  return selectedValue.findIndex((selectedOption: TSelectValue) => (typeof selectedOption === 'object'
    ? selectedOption.value === currentOption.value
    : selectedOption === currentOption.value)) !== -1;
};
